import { Icone } from './Icone'

/**
 * Le retour d'un écran de lecture — RG-D24, [DECISIONS §45] amendée.
 *
 * **En haut, et collée.** Elle flottait en bas à gauche : toujours visible,
 * mais loin de l'endroit où l'œil cherche une sortie, et posée par-dessus le
 * texte qu'on est en train de lire. En tête d'écran et collante, elle est au
 * seul endroit où l'on cherche un retour — et elle reste sous l'œil pendant
 * tout le défilement, ce qui était la raison d'être du bouton flottant.
 *
 * **Elle remplit l'en-tête resté vide.** Pendant une lecture, la barre
 * supérieure de la coque ne porte rien : le visage se tait (RG-D22ter) et
 * aucun titre ne s'y affiche. Cette barre occupe exactement cette bande, et
 * dit où l'on se trouve.
 *
 * `top-0` : pendant une lecture, la barre supérieure de la coque ne porte rien
 * — le visage s'y tait (RG-D22ter) — et ne réserve donc plus aucune hauteur.
 * Se caler à 53 px laissait une bande blanche entre les deux, qui mangeait une
 * ligne et demie de texte sur un téléphone.
 */
export function BarreDeRetour({
  libelle,
  fil,
  onClick,
}: {
  libelle: string
  /** Le chemin de lecture — « Botanique › Chapitre 1 ». */
  fil?: string | undefined
  onClick: () => void
}) {
  return (
    <div
      className="sticky top-0 z-10 -mx-4 mb-1 flex flex-col gap-0.5 border-b px-4 py-2 backdrop-blur-md"
      style={{
        borderColor: 'var(--bordure)',
        background: 'color-mix(in srgb, var(--fond) 85%, transparent)',
      }}
    >
      <button
        type="button"
        onClick={onClick}
        className="flex min-h-11 items-center gap-2 self-start text-[15px] font-bold"
        style={{ color: 'var(--accent-fort)' }}
      >
        <Icone nom="fleche-gauche" taille={18} />
        {libelle}
      </button>

      {fil !== undefined && (
        <p className="truncate text-[13px]" style={{ color: 'var(--texte-2)' }}>
          {fil}
        </p>
      )}
    </div>
  )
}
